export const AUTH_ENDPOINTS = {
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  LOGOUT: '/auth/logout',
  REFRESH_TOKENS: '/auth/refresh-tokens',
  QR_SESSION: '/auth/qr-session',
  QR_CONFIRM: '/auth/qr-confirm',
  QR_POLL: '/auth/qr-poll',
} as const;

export const USER_ENDPOINTS = {
  ME: '/users/me',
  USERS: '/users',
} as const;

export const PRODUCT_ENDPOINTS = {
  PRODUCTS: '/products',
} as const;

export const EQUIPMENT_ENDPOINTS = {
  EQUIPMENT: '/equipment',
} as const;

export const CONFIG_ENDPOINTS = {
  PROCESSING_STEPS: '/config/processing-steps',
} as const;

export const BATCH_ENDPOINTS = {
  BATCHES: '/batches',
  BATCH_DONE: '/batches/done',
  BATCH_RELEASED: '/batches/released',
} as const;

export const QUEUE_ENDPOINTS = {
  QUEUE: '/queue',
  QUEUE_REORDER: '/queue/reorder',
} as const;

export const BACKUP_ENDPOINTS = {
  BACKUP: '/backup',
} as const;

export const OVEN_PROGRAM_ENDPOINTS = {
  OVEN_PROGRAMS: '/oven-programs',
  IMPORT: '/oven-programs/import',
  EXPORT: '/oven-programs/export',
} as const;

export const METRICS_ENDPOINTS = {
  OVEN_UTILIZATION: '/metrics/oven-utilization',
  OVEN_STATS: '/metrics/ovens',
  BATCH_COMPLETION: '/metrics/batch-completion',
  MOISTURE_TREND: '/metrics/moisture-trend',
  USER_ACTIVITY: '/metrics/user-activity',
  SCHEDULE_LEAD_TIME: '/metrics/schedule-lead-time',
} as const;
